import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import BannerLanding from '../components/BannerLanding'
//import { Grid, Row, Col } from 'react-flexbox-grid';

const pageTitle = "Pack site vitrine";
const pageContent = ["Contenu de la prestation pour la création d'un site vitrine", "avec Wordpress ou un développement spécifique"];

const Generic = (props) => (
	<div style={props.transition && props.transition.style}>
		<Helmet>
			<title>Web2alpes - {pageTitle}</title>
			<meta name="description" content="Actions réalisées pour la création d'un site vitrine" />
			<meta name="language" content="fr-FR" />
            <meta http-equiv="content-type" content="text/html; charset=UTF-8" />
            <meta http-equiv="content-language" content="fr-FR" />
		</Helmet>
		<BannerLanding title={pageTitle} content={pageContent} particles="cms" color="style-logo-lg" />
		<div id="main" className="alt">
			<section id="support" className="tiles">
				<article className="full-medium">
					<div className="inner">
						<header className="major">
							<h2>Installation</h2>
						</header>
						<ul className="snow">
							<li>Mise en place d’une site Internet utilisant Wordpress (4.9) ou le framework React si c'est un développement personnalisé,</li>
							<li>Recherche de l'hébergeur et du registrar le plus adapté aux besoins,</li>
							<li>Inscription, activation de l’hébergement et du nom de domaine, installation site pilote vers version production,</li>
							<li>Optimisation du système de cache et minification du contenu de la boutique afin d'améliorer grandement les performances,</li>
							<li>Intégration d’un certificat HTTPS pour sécuriser le site Internet,</li>
							<li>Mise en place de la sauvegarde du site Internet</li>
						</ul>
					</div>
				</article>
				<article className="full-medium">
					<div className="inner">
						<header className="major">
							<h2>Accompagnement</h2>
						</header>
						<ul className="snow">
							<li>Mise en place des pages : accueil, mentions légales, formulaire de contact et à propos,</li>
							<li>Création des différents comptes utilisateurs pour l'exploitation du site Internet et du blog,</li>
							<li>Rédaction documentation (informations complètes site, comptes, hébergement)),</li>
							<li>Formation à distance ou sur site à la gestion d'un blog ou de la modification du contenu des pages</li>
						</ul>
					</div>
				</article>
				<article className="full-medium">
					<div className="inner">
						<header className="major">
							<h2>Referencement</h2>
						</header>
						<ul className="snow">
							<li>Intégration d’un module SEO pour l’optimisation du référencement naturel pour Wordpress,</li>
							<li>Mise en place de Google Analytics pour suivre votre référencement,</li>
							<li>Intégration du fichier sitemap XML pour faciliter l’indexation des moteurs de recherches,</li>
							<li>Intégration du plan du site pour limiter les niveaux de profondeur des pages,</li>
						</ul>
					</div>
				</article>
				<article className="full-medium">
					<div className="inner">
						<header className="major">
							<h2>Configuration</h2>
						</header>
						<ul className="snow">
							<li>Personnalisation du thème en fonction de votre identité visuelle et de vos attentes,</li>
							<li>Intégration de votre logo à votre site,</li>
							<li>Intégration de vos différents visuels en page d’accueil,</li>
							<li>Intégration de fonctionnalités des accès aux réseau sociaux : Facebook, Google+...,</li>
							<li>Intégration d’un bandeau d’information sur l’utilisation des cookies,</li>
						</ul>
					</div>
				</article>
			</section>
		</div>
	</div>
)

export default Generic



// WEBPACK FOOTER //
// ./src/pages/pack-site-vitrine.js